import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, GraduationCap, Bell, CheckCircle, X } from 'lucide-angular';
import { BehaviorSubject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WishlistModalComponent } from '../../../../components/wishlist-modal/wishlist-modal';
import { FeedbackApiService } from '../../../../../../../common/components/feedback-modal/feedback-api.service';

@Component({
  selector: 'app-grading-view',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, WishlistModalComponent],
  templateUrl: './grading-view.html',
  styleUrl: './grading-view.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradingViewComponent {
  private readonly feedbackApiService = inject(FeedbackApiService);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly icons = {
    GraduationCap,
    Bell,
    CheckCircle,
    X,
  };

  private readonly isWishlistModalOpen$$ = new BehaviorSubject<boolean>(false);
  protected readonly isWishlistModalOpen$ = this.isWishlistModalOpen$$.asObservable();

  private readonly isToastVisible$$ = new BehaviorSubject<boolean>(false);
  protected readonly isToastVisible$ = this.isToastVisible$$.asObservable();

  protected openWishlistModal(): void {
    this.isWishlistModalOpen$$.next(true);
  }

  protected closeWishlistModal(): void {
    this.isWishlistModalOpen$$.next(false);
  }

  protected onWishlistSubmit(data: { reason: string; feedbackType: string }): void {
    this.feedbackApiService
      .submitFeedback({
        feedbackType: data.feedbackType,
        feedbackText: data.reason,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.closeWishlistModal();
          this.showToast();
        },
        error: (err) => {
          console.error('Failed to submit wishlist feedback:', err);
          this.closeWishlistModal();
          this.showToast();
        },
      });
  }

  protected showToast(): void {
    this.isToastVisible$$.next(true);
    setTimeout(() => {
      this.hideToast();
    }, 5000);
  }

  protected hideToast(): void {
    this.isToastVisible$$.next(false);
  }
}
